/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MicrophoneIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABW0lEQVR4nOVUvU4CQRC+TgvjE2hNAo2V0cr2CufninUGKXink5eAkPAAdBKfgPAGlmoUGykMZpbFoLgcyMWY8CVT3M18++387CTJToBIjpGlC6xjM2TpIbpKaYcD6SOyTr+aPJlvawFk6S4fHoy0s7UA+JJEBFheSshAp6tsBwWA9Q5JBpsKwDdeXID01YjOuYNAjDYZSJ8tJk0bh/6bdbxOBiMLZq6fzjKQXnxMpe052dVZEBgVCiBLHkYw99/oKvaolm8vD1nWOPIxpDeLnNUC6KpA8o6sb0TXJ5+rgrRjc++NpD0/3GKAdOI56KqFAj5lkla46f1c5CeYz2JCRq1kXVw0m/vA2g+NnFgJrM7WeLNLrp/7f+ab1b5vnGQTpGm6ZzUN5YpMkfkkt9jktwDQmm886XBhyQ29OGgtKRNY1nr4UwGwFRB/aMWroQhIMog2mfW2lCz+NT4AHE5DeJtC4VUAAAAASUVORK5CYII=)
 */
export const MicrophoneIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 2a4 4 0 0 0-4 4v4a4 4 0 0 0 8 0V6a4 4 0 0 0-4-4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6 10a1 1 0 0 0-2 0 8 8 0 0 0 7 7.94V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.06A8 8 0 0 0 20 10a1 1 0 1 0-2 0 6 6 0 0 1-12 0Z"
        className={colorClass}
      />
    </svg>
  );
};
